import React from "react";
import single from "../../assets/popup/Check.png";
import danger from "../../assets/popup/Danger.png";

export default function TabPopup({ show, onClose, message, poptype = "Warning" }) {
  if (!show) return null;

  const imageToShow = poptype === "Warning" ? danger : single;

  return (
    <div className="popup-overlay fixed inset-0 flex items-center justify-center bg-black/40 z-50">
      <div className="popup-container relative bg-white rounded-xl shadow-lg w-96 p-6 text-center">
        
        <button
          className="popup-close absolute top-2 right-3 text-2xl text-gray-500 hover:text-gray-700"
          onClick={onClose}
        >
          ×
        </button>

        <div className="blue-half-circle flex justify-center mb-4">
          <img src={imageToShow} alt="Popup Icon" className="popup-image w-14 h-14" />
        </div>

        <div className="popup-content">
          <h4 className="text-xl font-semibold" style={{ color: "#823455" }}>
            {poptype}
          </h4>
          <p className="mt-3 fs-6 fw-medium text-secondary">{message}</p>
        </div>

      </div>
    </div>
  );
}
